import React, { useState, useEffect } from "react";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import NativeSelect from "@material-ui/core/NativeSelect";
import Switch from "@material-ui/core/Switch";
import { withTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import { useStylesSetting } from "./style";
import ConfirmModal from "../AlertModal/confirmModal";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useDarkmodeContext } from "react-use-dark-mode";
import { WalletClient, WalletMA } from "boa-sdk-ts";
import {
  COIN_NET,
  getNetworksURL,
  saveNetworksURL,
  TEST_NET,
} from "../../utils/WalletUtils";
import { usePrevious } from "../../hooks/usePrevious";
import { ErrorCheckUtil } from "../../utils/ErrorCheckUtil";
import { showMsg } from "../../actions/alertAction";
import { toastMsg } from "../../actions/toastAction";
const Setting = (props) => {
  // These are all states use in this component
  const dispatch = useDispatch();
  const { t, i18n, endpoint } = props;
  const { accounts } = WalletMA.instance();
  const classes = useStylesSetting();
  const [Language, setLanguage] = useState(i18n.language);
  //FIXME : Only TestNet
  const [points, setPoints] = useState("TEST");
  const [timeZone, setTimeZone] = useState("");
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const { mode, toggleMode } = useDarkmodeContext();

  const [stoaURL, setStoaURL] = useState("");
  const [agoraURL, setAgoraURL] = useState("");
  const previousStoaURL = usePrevious(stoaURL);
  const previousAgoraURL = usePrevious(agoraURL);
  const [disableEdit, setDisableEdit] = useState(true);

  useEffect(() => {
    if (i18n.language === "korean") {
      i18n.changeLanguage("korean");
      setLanguage("korean");
    } else if (i18n.language === "chinese_simplified") {
      i18n.changeLanguage("chinese_simplified");
      setLanguage("chinese_simplified");
    } else {
      i18n.changeLanguage("english");
      setLanguage("english");
    }
  }, [props.i18n.language]);

  useEffect(() => {
    if (props.getTimeZone && props.getTimeZone.TimeZone) {
      props.TimeZone(props.getTimeZone.TimeZone);
    } else {
      props.TimeZone("Local Time");
    }
    setPoints(endpoint);
  }, []);

  useEffect(() => {
    const n = getNetworksURL(points);
    setAgoraURL(n.agora);
    setStoaURL(n.stoa);
  }, [points]);

  useEffect(() => {
    setTimeZone(props.getTimeZone && props.getTimeZone.TimeZone);
  }, [props.getTimeZone]);

  // Method to change Timezone
  const handleChangeTimezone = (event) => {
    setTimeZone(event.target.value);
    props.TimeZone(event.target.value);
  };

  // Method to change languages
  const handleChangeLang = (event) => {
    setLanguage(event.target.value);
    i18n.changeLanguage(event.target.value);
  };

  // Method to change endpoints
  const handleChangePoints = (event) => {
    setPoints(event.target.value);
  };

  // Method of resetWallet
  const resetWallet = (info, status) => {
    setOpenConfirmModal(!openConfirmModal);
    if (status) {
      localStorage.clear();
      // props.SelectedAccount({});
      // props.SelectedAddress("");
      // props.MultiAddressesFunction([]);
      accounts.clear();
      props.history.push("/");
    }
  };

  const editModeHandler = () => {
    setDisableEdit(false);
  };
  const saveEndpointHandler = async () => {
    setDisableEdit(true);
    let client;
    try {
      const url = { agora: agoraURL, stoa: stoaURL };
      console.log("CHECK_URL:" + JSON.stringify(url));
      client = new WalletClient(url);
      const res = await client.checkServer();
      if (ErrorCheckUtil.resCodeCheck(res, false)) {
        saveNetworksURL(points, agoraURL, stoaURL);
        dispatch(toastMsg(t("Success")));
      } else {
        dispatch(showMsg(t("No_Response_URL")));
        setAgoraURL(previousAgoraURL);
        setStoaURL(previousStoaURL);
      }
    } catch (e) {
      setAgoraURL(previousAgoraURL);
      setStoaURL(previousStoaURL);
    } finally {
      client = null;
    }
  };

  return (
    <>
      <div className="Content">
        <div className="TableBg cardBg ph">
          <div className="row">
            <div className="col-md-6">
              {/* Select Language section */}
              <div className="SettingBox">
                <div className="selectTitle">
                  <h3>{t("Language")}</h3>
                </div>
                <div className="desktop_show">
                  <FormControl fullWidth className={classes.formControl}>
                    <Select
                      value={Language}
                      onChange={handleChangeLang}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                    >
                      <MenuItem value="english">🇺🇸 English</MenuItem>
                      <MenuItem value="korean">🇰🇷 한국어</MenuItem>
                      <MenuItem value="chinese_simplified">🇨🇳 中文</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mobile_show">
                  <FormControl fullWidth className={classes.formControl}>
                    <NativeSelect
                      value={Language}
                      onChange={handleChangeLang}
                      className={classes.selectEmpty}
                      inputProps={{ "aria-label": "age" }}
                    >
                      <option value="english">🇺🇸 English</option>
                      <option value="korean">🇰🇷 한국어</option>
                      <option value="chinese_simplified">🇨🇳 中文</option>
                    </NativeSelect>
                  </FormControl>
                </div>
              </div>
              {/* Select CoinNet or TestNet section */}
              <div className="SettingBox">
                <div className="endPoints">
                  <div className="selectTitle">
                    <h3>{t("Endpoints")}</h3>
                  </div>
                  <div className="desktop_show">
                    <FormControl
                      fullWidth
                      className={`${classes.formControl} ${"testNetDot"}`}
                    >
                      <Select
                        value={points}
                        onChange={handleChangePoints}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                      >
                        {/*FIXME : Only TestNet*/}
                        <MenuItem disabled value={COIN_NET}>
                          {t("CoinNet")}
                        </MenuItem>
                        <MenuItem value={TEST_NET}>{t("TestNet")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mobile_show">
                    <FormControl
                      fullWidth
                      className={`${classes.formControl} testNetDot`}
                    >
                      <NativeSelect
                        value={points}
                        onChange={handleChangePoints}
                        className={classes.selectEmpty}
                        inputProps={{ "aria-label": "age" }}
                      >
                        {/*FIXME : Only TestNet*/}
                        <option disabled value={COIN_NET}>
                          {t("CoinNet")}
                        </option>
                        <option value={TEST_NET}>{t("TestNet")}</option>
                      </NativeSelect>
                    </FormControl>
                  </div>
                </div>
                {/* Display connected end points  */}
                <div className="StringInput">
                  <TextField
                    label="Agora"
                    value={agoraURL}
                    disabled={disableEdit}
                    onChange={(e) => {
                      setAgoraURL(e.target.value);
                    }}
                  />
                </div>
                <div className="StringInput">
                  <TextField
                    label="Stoa"
                    value={stoaURL}
                    disabled={disableEdit}
                    onChange={(e) => {
                      setStoaURL(e.target.value);
                    }}
                  />
                </div>
                <div className="StringInput">
                  <div className="editEndpoint">
                    <button
                      hidden={!disableEdit}
                      className="btn btn-default ClearBtn"
                      onClick={editModeHandler}
                    >
                      {t("Edit")}
                    </button>
                    <button
                      hidden={disableEdit}
                      className="btn btn-default ClearBtn"
                      onClick={saveEndpointHandler}
                    >
                      {t("Save")}
                    </button>
                  </div>
                </div>
              </div>
              {/* Reset wallet states section */}
              <div className="SettingBox">
                <div>
                  <h3>{t("Reset_Wallet_State")}</h3>
                </div>
                <div>
                  <div>
                    {/* Button to reset all wallet data */}
                    <button
                      className="btn btn-default ClearBtn"
                      onClick={() => resetWallet("", false)}
                    >
                      {t("Clear")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              {/* Select time zone section */}
              <div className="SettingBox">
                <div className="selectTitle">
                  <h3>{t("Timezone")}</h3>
                </div>
                <div className="desktop_show">
                  <FormControl fullWidth>
                    <Select
                      value={timeZone}
                      onChange={handleChangeTimezone}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                    >
                      <MenuItem value="Local Time">{t("Local_Time")}</MenuItem>
                      <MenuItem value="UTC">UTC</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mobile_show">
                  <FormControl fullWidth>
                    <NativeSelect
                      value={timeZone}
                      onChange={handleChangeTimezone}
                      className={classes.selectEmpty}
                      inputProps={{ "aria-label": "timezone" }}
                    >
                      <option value="Local Time">{t("Local_Time")}</option>
                      <option value="UTC">UTC</option>
                    </NativeSelect>
                  </FormControl>
                </div>
              </div>
              {/* Change theme color options */}
              <div className="SettingBox">
                <div>
                  <h3>{t("Dark_Mode")}</h3>
                </div>
                <div>
                  <Switch
                    color="primary"
                    checked={mode === "light" ? false : true}
                    name="toggleSatus"
                    inputProps={{ "aria-label": "primary checkbox" }}
                    onChange={toggleMode}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Clear wallet states confirmation modal */}
      <ConfirmModal
        open={openConfirmModal}
        actionEventConfirm={resetWallet}
        message={t("clear_all_states_wallet")}
      />
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Setting))
);
